import React from "react";
import "./Sector_We_Serve_card.css";
import Lottie_Holder from "../../../Lottie_Holder/Lottie_Holder"

function Sector_We_Serve_card({title,animationData, text}) {
  return (
    <>
      <section className="Sector_We_Serve_card">
        <div className="card_heading_holder">
          <h5>{title}</h5>
        </div>

        <div className="card_lottie_holder">
        <Lottie_Holder animationData={animationData}/>
        </div>

        <div className="card_text_holder">
          <p>
          {text}
          </p>
        </div>
      </section>
    </>
  );
}

export default Sector_We_Serve_card;
